module.exports = __webpack_public_path__ + "static/media/savingsIcon.a66e2d52.svg";